import m from "../../geodata/es2015/italyHigh";
window.am4geodata_italyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/italyHigh.js
// module id = null
// module chunks = 